export const FILTER_DEBOUNCE_TIME = 1000;
export const FILTER_MIN_CHARACTERS = 3;
